// Module
var code = "<template>\n  <require from=\"../pluck-list/pluck-list\"></require>\n  <pluck-list production-order-id.bind=\"productionOrderId\" pluck-list.bind=\"pluckList\" on-save.call=\"onSave($event)\"></pluck-list>\n</template>\n";
// Exports
export default code;